<template>
  <div class="weui-cells weui-cells_form" style="background: white">
    <h3 class="page__title">退款申请管理</h3>
    <div class="weui-cell weui-cell_active weui-cell_vcode" style="color: black">
        <div class="weui-cell__hd">
            <label class="weui-label">处理状态</label>
        </div>
        <div class="weui-cell__bd weui-cell__bd-WU">
            <input class="weui-input" style="text-align:center" type="text" placeholder="0 待处理，1 处理完毕，-1 驳回,-2 人工" v-model="state" />
        </div>
    </div>
    <div class="weui-cell weui-cell_active weui-cell_vcode" style="color: black">
        <div class="weui-cell__hd">
            <label class="weui-label">用户ID</label>
        </div>
        <div class="weui-cell__bd weui-cell__bd-WU">
            <input class="weui-input" style="text-align:center" type="text" placeholder="输入用户OpenID" v-model="userid" />
        </div>
    </div>
    <div class="weui-cell weui-cell_active weui-cell_vcode" v-if="partnerid != 'M2022060601'">
        <div class="weui-cell__hd">
            <label class="weui-label">商户ID</label>
        </div>
        <div class="weui-cell__bd weui-cell__bd-WU">
            <input class="weui-input" style="text-align:center" type="text" placeholder="输入商户ID" v-model="pid" />
        </div>
    </div>
    <div class="weui-cell weui-cell_active weui-cell_vcode" >
        <div class="weui-cell__hd">
        </div>
        <div class="weui-cell__bd">
          <a @click="getMyRefundRecord" class="weui-btn weui-btn_primary">查询</a>
        </div>
    </div>
    <div v-if="(recordsRefund != null) && (recordsRefund.length > 0)">
     <hr/>
      <table class="table table-striped " style="font-size: small;" >
            <thead>
               <td>申请时间</td>
               <td>退款金额</td>
               <td>状态</td>
            </thead>
            <tbody style="padding: 0px;margin:0px">
              <tr v-for="rcd in recordsRefund" :key="rcd.id" @click="refundPre(rcd)">
                <td>{{ rcd.createTime }}</td>
                <td>{{ fenToCNY(rcd.expectRefundAmount) }}</td>
                <td @click="refundPre(rcd)">{{ getRState(rcd.applyState) }}</td>
              </tr>
            </tbody>
            <tfoot>

            </tfoot>
          </table>
    </div>
    <div class="weui-mask" id="iosMaskDlg" style="display: none;" @click="hideDlg"></div>
    <div class="weui-actionsheet" id="curRecordDlg">
      <!--
        <div class="weui-actionsheet__title">
            <p class="weui-actionsheet__title-text">{{title}}</p>
        </div>
      -->
        <div class="weui-actionsheet__menu" v-if="curRecord != null">
          <table class="table table-striped " style="font-size: small;" >
            <tr><td>申请时间</td><td>{{ curRecord.createTime }}</td></tr>
            <tr><td>用户信息</td><td><a style="color:blue" @click="toUrl(curRecord.userAccount)">新{{fenToCNY(userInfo.nb)}} / 旧{{fenToCNY(userInfo.ob)}} </a></td></tr>
            <tr><td>商户号</td><td>{{ curRecord.partnerId }}</td></tr>
            <tr><td>退款金额</td><td>{{ fenToCNY(curRecord.expectRefundAmount) }}</td></tr>
            <tr><td>已退金额(新)</td><td>{{ fenToCNY(curRecord.zhmRefundAmount)  }} </td></tr>
            <tr><td>已退金额(旧)</td><td>{{ curRecord.ycbRefundAmount }}</td></tr><!--
            <tr><td>备注信息</td><td>{{ curRecord.desc }}</td></tr>
            <tr><td>操作员</td><td>{{ curRecord.operator }}</td></tr>  {{ curRecord.userAccount }}
            <tr><td>处理时间</td><td>{{ curRecord.modifyTime }}</td></tr>  -->
            <tr><td>状态</td><td>{{ getRState(curRecord.applyState) }}</td></tr>
            <tr><td>待退款额度</td><td>{{ fenToCNY(curRecord.expectRefundAmount - curRecord.zhmRefundAmount - curRecord.ycbRefundAmount )  }}</td></tr>
            <tr v-if="(n_refund_amt > 0) && (curRecord.applyState == -2 )"><td>操作（新）</td>
              <td>
                <!--
                <input class="weui-input" style="text-align:center" type="text" placeholder="输入新系统人工退款金额" v-model="n_refund_amt" />
                -->
                <a class="weui-btn weui-btn_primary" @click="refundBalance(curRecord.refundApplyId)">
                  确认新系统已退{{ fenToCNY(n_refund_amt) }}</a>
              </td>
            </tr>
            <tr v-if="(o_refund_amt > 0) && (curRecord.applyState == -2 )"><td>操作（旧）</td>
              <td>
                <!--
                <input class="weui-input" style="text-align:center" type="text" placeholder="输入旧系统人工退款金额" v-model="o_refund_amt" />
                 -->
                <a class="weui-btn weui-btn_primary" @click="refundOldBalance(curRecord.refundApplyId)">
                  确认旧系统已退{{ fenToCNY(o_refund_amt)  }}</a>
              </td>
            </tr>
            <tr v-if="(o_refund_amt + n_refund_amt == 0) && (curRecord.applyState == -2 )"><td>操作</td>
              <td>
                <!--
                <input class="weui-input" style="text-align:center" type="text" placeholder="输入旧系统人工退款金额" v-model="o_refund_amt" />
                 -->
                <a class="weui-btn weui-btn_primary" @click="refundComplete(curRecord.refundApplyId)">
                  关闭退款单</a>
              </td>
            </tr>
          </table>
        </div>
        <!--
        <div class="weui-actionsheet__action">
            <div class="weui-actionsheet__cell" id="iosActionsheetCancel">关闭</div>
        </div>
      -->
    </div>
  </div>
</template>

<style>
.a_hot_touch{color:blue;font-style:italic;text-decoration:underline;}
</style>

<script>

import axios from "axios"
import JQ from 'jquery'
import wx from 'jweixin-1.6.0';
import {getPoints,geRefundRecords} from '../graphql/api'

export default {
data () {
  return {
    ing:true,
    partnerid:"",
    pid:null,
    userid:null,
    state:-2,
    recordsRefund:null,
    curRecord:null,
    userList:[],
    userInfo:{nb:0,ob:0},
    n_refund_amt:0,
    o_refund_amt:0,
  }
},
mounted() {
     this.partnerid = sessionStorage.getItem("partnerid")

     this.getMyRefundRecord();
},
methods: {
  getuserInfo(openid) {
      console.log("getuserInfo")
      this.userList=[];

      let paras = {};

      paras.openid = openid;

      let that = this;
      axios.get('/zmomc/getUserListByComplex', {
        params: paras
      })
      .then(function (response) {
        console.log(response);
        that.userList = response.data

        that.userInfo.nb = 0;
        that.userInfo.ob = 0;
        that.userList.forEach(item => {
          that.userInfo.nb += item.balance;
          that.userInfo.ob += item.obalance;
       });

       let amt = that.curRecord.expectRefundAmount - that.curRecord.zhmRefundAmount - that.curRecord.ycbRefundAmount;

       that.o_refund_amt = 0;
      that.n_refund_amt = 0
       if(amt > 0){
        if(that.userInfo.ob > 0){
          if(that.userInfo.ob >= amt){
            that.o_refund_amt = amt;
            that.n_refund_amt = 0
          }else{
            that.o_refund_amt = that.userInfo.ob;
            that.n_refund_amt = amt - that.userInfo.ob;
          }
        }
       }


       console.log(that.userInfo);

        that.showDlg();
      })
      .catch(function (error) {
        console.log(error);
      });
    },
  getMyRefundRecord(){
    let that = this
    let paras = {};

    paras.pid = this.partnerid;
    paras.state = this.state;
    paras.acc = this.userid;


    geRefundRecords(paras)
    // findAllWeChatAccDailyStatement(that.partnerid,{bd:"2022-12-01",ed:"2022-12-05 23:59:59",ls:[1,2],lt:[1,2,3,4]})
    .catch(err=>{
      console.log(err)
    })
    .then(res1=>{
     // alert(1)
      console.info('获取数据=》'+JSON.stringify(res1.data))
      //alert(JSON.stringify(res1.data))
      that.recordsRefund = res1.data.queryRefundApply

    })
  },
  getRState(istate){if(istate == 1) return "成功退款"; if(istate == 0) return "处理中"; if(istate == -1) return "驳回申请";if(istate == -2) return "人工处理中";},
  fenToCNY(fen){
    let prefix = "";
    let res= ""
    let intv = parseInt(fen)

    if(intv < 0) {
      intv = Math.abs(intv);
      prefix = "-";
    }

    if(intv <= 9){
      res = "0.0"+ ( intv).toString();
    }else if(intv <= 99){
      res =  "0."+ ( intv).toString();
    }else {
      res = intv.toString();

      res = res.substring(0,res.length-2) + "." + res.substring(res.length-2)
    }
    return prefix+res;

  },
  toUrl(openid){
      this.$router.push({name:"userlist",params:{
        userAccount:openid
      }});
    },
  toDir(str) {
      this.$router.push({
        name: str /*,
        params: {
          dateStr: date,
          state: state,
          posid: 0
        }*/
      });
    },
    hideDlg(){
      JQ('#curRecordDlg').removeClass('weui-actionsheet_toggle up80px');
      JQ('#iosMaskDlg').fadeOut(200);
    },
    showDlg(){
      JQ('#curRecordDlg').addClass('weui-actionsheet_toggle up80px');
      JQ('#iosMaskDlg').fadeIn(200);
    },
    refundPre(rcd){
      console.log(rcd)
      this.curRecord = rcd

      this.getuserInfo(rcd.userAccount)
    },
    refundBalance(tid) {
    console.log("refundBalance")

    let amt = this.n_refund_amt;

    let that = this;
    axios.get('customer/omc/manualRefund?refundApplyId='+tid+'&refundAmount='+amt)
    .then(function (response) {
      console.log(response);
      if(response.data.retcode == 0){
        that.getMyRefundRecord();
      }else{

        alert(response.data.retmsg)
      }

      that.hideDlg()

    })
    .catch(function (error) {
      console.log(error);
    });
  },
    refundOldBalance(tid) {
    console.log("refundComplete")

    let amt = this.o_refund_amt;

    let paras = {};

    paras.refundApplyId = tid;
    paras.ycbRefundAmount = amt;
    paras.applyState = this.curRecord.applyState;

    if(amt != 0)
    paras.refundDesc = "管理员确认旧系统已经退款"+amt;

    let that = this;
    axios.post('customer/omc/refundApplyModify',paras)
    .then(function (response) {
      console.log(response);
      if(response.data.retcode == 0){
        that.getMyRefundRecord();
      }else{

        alert(response.data.retmsg)
      }

      that.hideDlg()

    })
    .catch(function (error) {
      console.log(error);
    });
  },
    refundComplete(tid) {
    console.log("refundComplete")

    let amt = this.userInfo.o_refund_amt;

    let paras = {};

    paras.refundApplyId = tid;
    paras.ycbRefundAmount = this.curRecord.ycbRefundAmount;
    paras.applyState = 1;

    paras.refundDesc = "\n管理员手动结束订单,确认旧系统已经处理";

    let that = this;
    axios.post('customer/omc/refundApplyModify',paras)
    .then(function (response) {
      console.log(response);
      if(response.data.retcode == 0){
        that.getMyRefundRecord();
      }else{

        alert(response.data.retmsg)
      }

      that.hideDlg()

    })
    .catch(function (error) {
      console.log(error);
    });
  }
 }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/refund_apply_mgr.vue